module.exports = __webpack_public_path__ + "static/media/DistractionTechniques.c3e4aaa8.mp3";